import { render, staticRenderFns } from "./ResumoPedidos.vue?vue&type=template&id=ab8866d0&scoped=true"
import script from "./ResumoPedidos.vue?vue&type=script&lang=js"
export * from "./ResumoPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8866d0",
  null
  
)

export default component.exports